







import {Component, Vue} from 'vue-property-decorator';
import AlertBody from "@/components/alert/AlertBody.vue";
import GlobalHeader from "@/components/GlobalHeader.vue";

@Component({
    components: {AlertBody, GlobalHeader}
})
export default class Alert extends Vue {}
